export var expectedExpression = 'Expected a JavaScript expression';
export var expectedParen = 'Expected closing paren';
